import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('usersettings.rinnova-offerta-summary', {
            url: '/rinnova-offerta-summary',
            views: {
                'userContent': {
                    template: '<rinnova-offerta-summary></rinnova-offerta-summary>'
                }
            },
            ncyBreadcrumb: {
                label: 'Rinnova Offerta Riepelogo',
                parent: 'usersettings.gestione-offerta'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Rinnova Offerta Rieplogo'
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const RinnovoOffertaSummaryModule: string = ng
    .module('archiSmall.userSettings.rinnovoOffertaSummaryModule', [
        'ui.bootstrap',
        uiRouter,
        'ncy-angular-breadcrumb'
    ])
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/rinnova-offerta-summary/rinnova-offerta-summary.module.ts